import styled from 'styled-components';

export const WrapContent = styled.span`
  white-space: normal;
  text-transform: ${({ lowercase }) => (lowercase ? 'lowercase' : 'none')};
`;
